import React from "react";
import { managerAxios } from "../../axiosInstance";
import * as XLSX from "xlsx";

function ExportSalesList() {
  const handleDownload = async () => {
    try {
      const response = await managerAxios.get("orders/download", null);

      const filteredData = response?.data?.data?.map((item, index) => ({
        // "Image":,
        NO: index + 1,
        "ORDER NO": item?.orderNO,
        "CASHIER NAME": `${item?.user?.firstname} ${item?.user?.lastname}`,
        "CUSTOMER NAME": item?.customer?.name,
        "PAYMENT METHOD": item?.payment_type,
        "QUANTITY SOLD": item?.orderdetails[0]?.quantity_ordered,
        "TOTAL PRICE": item?.total_price,
        STATUS: item.status,
      }));

      const ws = XLSX.utils.json_to_sheet(filteredData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Sales.xlsx");
    } catch (err) {
      console.log("Error fetching data", err);
    } finally {
      //   setIsLoading(false);
      // setIsNextLoading(false);
      // setIsPrevLoading(false);
    }
  };
  return (
    <button
      onClick={() => handleDownload()}
      className="px-4 py-3 text-white rounded-lg bg-green-500"
    >
      Export Sales
    </button>
  );
}

export default ExportSalesList;
